export default __webpack_public_path__ + "static/media/logosukses1.312ef85f.png";